/**
 * Empresa Compás bajo proyecto: NML | STAGE (fijos de momento).
 */

export const ORG_BRANDS = Object.freeze(["NML", "STAGE"]);

export function normalizeOrgBrand(raw, { fallback = "STAGE" } = {}) {
  const v = String(raw || "")
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_");
  if (v === "NML") return "NML";
  if (v === "STAGE" || v === "STG") return "STAGE";
  const fb = String(fallback || "STAGE")
    .trim()
    .toUpperCase();
  return fb === "NML" ? "NML" : "STAGE";
}

/** Cliente BHOEM → NML; resto → STAGE (migración / default). */
export function orgBrandFromCustomerName(name) {
  const s = String(name || "")
    .trim()
    .toUpperCase();
  if (!s) return "STAGE";
  if (/\bBHOEM\b/.test(s) || s.includes("BHOEM")) return "NML";
  return "STAGE";
}

export function orgBrandFromRow(row, { fallback = "STAGE" } = {}) {
  if (row == null) return normalizeOrgBrand(fallback);
  const direct = row.OrgBrand ?? row.orgBrand;
  if (direct != null && String(direct).trim() !== "") {
    return normalizeOrgBrand(direct, { fallback });
  }
  const name =
    row.CustomerName ??
    row.customerName ??
    row.ClientName ??
    row.clientName ??
    "";
  return orgBrandFromCustomerName(name);
}

/**
 * Partir filas por OrgBrand (lazy tree).
 * @returns {{ NML: any[], STAGE: any[] }}
 */
export function partitionRowsByOrgBrand(rows = []) {
  const out = { NML: [], STAGE: [] };
  for (const row of Array.isArray(rows) ? rows : []) {
    const brand = orgBrandFromRow(row);
    out[brand].push(row);
  }
  return out;
}

export function otherOrgBrand(brand) {
  return normalizeOrgBrand(brand) === "NML" ? "STAGE" : "NML";
}
